import { LoanStatus } from 'constants/loanApplication';
import { TagColor } from 'constants/ui';

export const tagPropsByStatus = {
  [LoanStatus.TBD_BUNDLE_ISSUED]: {
    color: TagColor.YELLOW,
  },
  [LoanStatus.PREQUAL_STARTED]: {
    color: TagColor.YELLOW,
  },
  [LoanStatus.DID_NOT_PREQUAL]: {
    color: TagColor.RED,
  },
  [LoanStatus.LEGACY_SYSTEM_LOAN]: {
    color: TagColor.GREEN,
  },
  [LoanStatus.UNDEFINED]: {
    color: TagColor.RED,
  },
  [LoanStatus.UW_SUSPENDED]: {
    color: TagColor.RED,
  },
  [LoanStatus.APPROVED_NOT_ACCEPTED]: {
    color: TagColor.RED,
  },
  [LoanStatus.WITHDRAWN]: {
    color: TagColor.RED,
  },
  [LoanStatus.UW_DENIED]: {
    color: TagColor.RED,
  },
  [LoanStatus.CLOSED_FOR_INCOMPLETENESS]: {
    color: TagColor.RED,
  },
  [LoanStatus.PROCESSING]: {
    color: TagColor.GREEN,
  },
  [LoanStatus.APPLICATION_STARTED]: {
    color: TagColor.YELLOW,
  },
  [LoanStatus.APPLICATION_COMPLETED_NO_RATES]: {
    color: TagColor.YELLOW,
  },
  [LoanStatus.APPLICATION_COMPLETED_HAS_RATES]: {
    color: TagColor.YELLOW,
  },
  [LoanStatus.DISCLOSURES_GENERATED]: {
    color: TagColor.YELLOW,
  },
  [LoanStatus.DISCLOSURES_SIGNED_PARTIALLY]: {
    color: TagColor.YELLOW,
  },
  [LoanStatus.UW]: {
    color: TagColor.YELLOW,
  },
  [LoanStatus.ABNORMAL_NOT_SCHEDULED]: {
    color: TagColor.YELLOW,
  },
  [LoanStatus.DISCLOSURES_COMPLETED]: {
    color: TagColor.GREEN,
  },
  [LoanStatus.TASKS_REMAINING]: {
    color: TagColor.GREEN,
  },
  [LoanStatus.LO_ASSIGNMENT_ERROR]: {
    color: TagColor.RED,
  },
  [LoanStatus.UW_APPROVED]: {
    color: TagColor.GREEN,
  },
  [LoanStatus.CLEAR_TO_CLOSE]: {
    color: TagColor.GREEN,
  },
  [LoanStatus.SCHEDULED]: {
    color: TagColor.GREEN,
  },
  [LoanStatus.CLOSED]: {
    color: TagColor.GREEN,
  },
  [LoanStatus.FUNDED]: {
    color: TagColor.GREEN,
  },
  [LoanStatus.CANCELED]: {
    color: TagColor.RED,
  },
  [LoanStatus.LEAD]: {
    color: TagColor.YELLOW,
  },
};
